import React, { useEffect, useState } from "react";
import {
  Form,
  Button,
  Container,
  ButtonGroup,
  ToggleButton,
  Card,
  Row,
  Col,
} from "react-bootstrap";
import { Stepper, Step } from "react-form-stepper";
import ArrowIcon from "../assets/images/arrow-right.svg";
import BackArrowIcon from "../assets/images/black-back-arrow.svg";
import HeadingLines from "../assets/images/heading-lines.svg";
import CheckoutComp from "./CheckoutComp";
import "../scss/checkout.scss";

import { useDispatch, useSelector } from "react-redux";
import { getStarted } from "../features/auth/authActions";
import { toast } from "react-toastify";
import { formatPrice } from "../helpers/helpers";
import { useLocation, useNavigate } from "react-router-dom";

const SignupStepComp = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const { getStartedOptionData } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(getStarted());
  }, [dispatch]);

  useEffect(() => {
    if (getStartedOptionData) {
      setSelectedDescribeYourselfOption(
        getStartedOptionData?.describe_options[0]?.id || ""
      );
      setSelectedCostTypeOption(
        getStartedOptionData?.cost_type_options[0]?.id || ""
      );
      setSelectedServiceStartOption(
        getStartedOptionData?.service_start_type_options[0]?.id || ""
      );
    }
  }, [getStartedOptionData]);

  const [step, setStep] = useState(0);

  const handleNext = () => {
    if (step === 2) {
      const isValid = validateStepTwo(); // your validation logic here
      if (!isValid) {
        // show error or stop here
        return;
      }
    }

    if (step === 4) {
      let serviceOptions = getStartedOptionData?.booking_service_options;
      let orderData = {
        age: ageGroup,
        who_need_care: radioValue,
        describe_your_self: selectedDescribeYourselfOption,
        services: serviceOptions?.filter((option) =>
          selectedServiceOptions.includes(option.id)
        ),
        cost_type: selectedCostTypeOption,
        service_start: selectedServiceStartOption,
      };
      localStorage.setItem("orderData", JSON.stringify(orderData));
    }

    // If validation passes or it's not step 4, move to next step
    setStep((prevStep) => prevStep + 1);
  };

  const validateStepTwo = () => {
    if (selectedServiceOptions.length === 0) {
      // Optionally show error message
      toast.error("Please select an option.");
      return false;
    }
    return true;
  };

  const handleBack = () => setStep((prevStep) => prevStep - 1);

  // Step 1
  const [ageGroup, setAgeGroup] = useState("30s");
  const radios = [
    { name: "My Parent", value: "parent" },
    { name: "My Spouse", value: "spouse" },
    { name: "Myself", value: "myself" },
    { name: "Others", value: "others" },
  ];
  const [radioValue, setRadioValue] = useState(radios[0]?.value || ""); // default to first radio value

  const handleSelectChange = (e) => {
    setAgeGroup(e.target.value);
  };

  // Step 2
  const [selectedDescribeYourselfOption, setSelectedDescribeYourselfOption] =
    useState("");

  // Step 3
  const [selectedServiceOptions, setSelectedServiceOptions] = useState([]); // State to track selected checkboxes
  const handleServiceCheckboxChange = (id) => {
    setSelectedServiceOptions((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((item) => item !== id)
        : [...prevSelected, id]
    );
  };

  // Step 4
  const [selectedCostTypeOption, setSelectedCostTypeOption] = useState("");

  // Step 5
  const [selectedServiceStartOption, setSelectedServiceStartOption] =
    useState("");

  const renderStep = () => {
    switch (step) {
      case 0:
        return (
          <Form>
            <div className="w-100">
              <h3>Who needs care?</h3>
              <ButtonGroup toggle className="radio-group">
                {radios.map((radio, idx) => (
                  <div className="radio-item" key={idx}>
                    <ToggleButton
                      id={`radio-${idx}`}
                      type="radio"
                      variant={
                        radio.value === radioValue
                          ? "radio-select"
                          : "radio-button"
                      }
                      name="radio"
                      value={radio.value}
                      checked={radioValue === radio.value ? "checked" : ""} // check current
                      onChange={(e) => setRadioValue(e.currentTarget.value)}
                    >
                      {radio.name}
                    </ToggleButton>
                  </div>
                ))}
              </ButtonGroup>
              <Form.Group className="form-group">
                <h3>How old are they?</h3>
                <Form.Select value={ageGroup} onChange={handleSelectChange}>
                  {Array.from({ length: 20 }, (_, i) => {
                    const age = (i + 1) * 5;
                    return (
                      <option key={age} value={`${age}s`}>
                        {age}s
                      </option>
                    );
                  })}
                </Form.Select>
              </Form.Group>
            </div>
          </Form>
        );
      case 1:
        return (
          <Form>
            <div className="w-100">
              <h3>How would you describe yourself?</h3>
              {getStartedOptionData?.describe_options.map((option, idx) => (
                <Card
                  key={idx}
                  className={`${
                    selectedDescribeYourselfOption === option.id
                      ? "selected"
                      : ""
                  }`}
                  onClick={() => setSelectedDescribeYourselfOption(option.id)}
                >
                  <Card.Body className="d-flex align-items-center p-0">
                    <Form.Check
                      type="radio"
                      name="description-options"
                      id={`option-${idx}`}
                      value={option.id}
                      checked={selectedDescribeYourselfOption === option.id}
                      onChange={() =>
                        setSelectedDescribeYourselfOption(option.id)
                      }
                    />
                    <div>
                      <Card.Title>{option.title}</Card.Title>
                      <Card.Text>{option.description}</Card.Text>
                    </div>
                  </Card.Body>
                </Card>
              ))}
            </div>
          </Form>
        );
      case 2:
        return (
          <Form>
            <h3>What kind of help are you looking for?</h3>
            <Row className="justify-content-center">
              {getStartedOptionData?.booking_service_options.map(
                (option, idx) => (
                  <Col sm={12} md={6} xl={4} key={idx}>
                    <Card
                      className={`w-100 ${
                        selectedServiceOptions.includes(option.id)
                          ? "selected"
                          : ""
                      }`}
                    >
                      <Form.Check
                        type="checkbox"
                        id={`checkbox-${idx}`}
                        value={option.id}
                        checked={selectedServiceOptions.includes(option.id)}
                        onChange={() => handleServiceCheckboxChange(option.id)}
                        label={
                          <div className="checkbox-wrap">
                            <h4>{option.title}</h4>
                            <p>{option.description}</p>
                            <h3 className="price-tag">
                              $ {formatPrice(option.price)}
                            </h3>
                          </div>
                        }
                      />
                    </Card>
                  </Col>
                )
              )}
            </Row>
          </Form>
        );
      case 3:
        return (
          <div>
            <Form>
              <h3>How are you thinking about covering the cost?</h3>
              <Row className="justify-content-center">
                {getStartedOptionData?.cost_type_options.map((option, idx) => (
                  <Col md={6} key={idx} className="mb-4">
                    <Card
                      className={`w-100 h-100 mb-0 ${
                        selectedCostTypeOption === option.id ? "selected" : ""
                      }`}
                      onClick={() => setSelectedCostTypeOption(option.id)}
                    >
                      <Card.Body className="d-flex align-items-center p-0">
                        <Form.Check
                          type="radio"
                          name="description-options"
                          id={`option-${idx}`}
                          value={option.id}
                          checked={selectedCostTypeOption === option.id}
                          onChange={() => setSelectedCostTypeOption(option.id)}
                        />
                        <div>
                          <Card.Title>{option.title}</Card.Title>
                          <Card.Text>{option.description}</Card.Text>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Form>
          </div>
        );
      case 4:
        return (
          <Form>
            <div className="w-100">
              <h3>When do you want to start?</h3>
              {getStartedOptionData?.service_start_type_options.map(
                (option, idx) => (
                  <Card
                    key={idx}
                    className={`${
                      selectedServiceStartOption === option.id ? "selected" : ""
                    }`}
                    onClick={() => setSelectedServiceStartOption(option.id)}
                  >
                    <Card.Body className="d-flex align-items-center p-0">
                      <Form.Check
                        type="radio"
                        name="description-options"
                        id={`option-${idx}`}
                        value={option.id}
                        checked={selectedServiceStartOption === option.id}
                        onChange={() =>
                          setSelectedServiceStartOption(option.id)
                        }
                      />
                      <div>
                        <Card.Title>{option.title}</Card.Title>
                        <Card.Text>{option.description}</Card.Text>
                      </div>
                    </Card.Body>
                  </Card>
                )
              )}
            </div>
          </Form>
        );
      case 5:
        return <CheckoutComp step={step} handleBack={handleBack} />;
      default:
        return null;
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const stepRedirect = params.get("step");

    if (stepRedirect) {
      let orderData = localStorage.getItem("orderData");
      if (orderData) {
        orderData = JSON.parse(orderData);
        setAgeGroup(orderData.age);
        setSelectedCostTypeOption(orderData.cost_type);
        setSelectedDescribeYourselfOption(orderData.describe_your_self);
        setSelectedServiceOptions(orderData.services);
        setSelectedServiceStartOption(orderData.service_start);
        setRadioValue(orderData.who_need_care);
      }

      setStep(5);

      // Remove 'step' from the URL
      params.delete("step");
      
      navigate(
        {
          pathname: location.pathname,
          search: params.toString(),
        },
        { replace: true }
      );
    }
  }, [location.search, location.pathname, navigate, step]);

  return (
    <section className="signup-step-form" id="SignupStepForm">
      <Container>
        <div className="signup-step-form-header">
          <img src={HeadingLines} alt="" />
          <h2>
            Let’s get started by learning more about your senior care needs.
          </h2>
        </div>
        <Stepper activeStep={step}>
          <Step />
          <Step />
          <Step />
          <Step />
          <Step />
          <Step />
        </Stepper>

        {renderStep()}

        {/* Navigation Buttons */}
        {step < 5 && (
          <div className="form-button--group">
            {step > 0 && step < 5 && (
              <Button className="custom-bttn back-bttn" onClick={handleBack}>
                <img src={BackArrowIcon} alt="Back" /> Back
              </Button>
            )}
            {step < 5 && (
              <Button className="custom-bttn next-btn" onClick={handleNext}>
                Continue <img src={ArrowIcon} alt="Next" />
              </Button>
            )}
          </div>
        )}
      </Container>
    </section>
  );
};

export default SignupStepComp;
